import { takeLatest, put, call, select } from 'redux-saga/effects';
import { FIND_KEY_NUMBER_SAGA } from "../sagaTypes";
import { loaderAction, keyNumberAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { KEY_NUMBER_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/find_key_number`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerFindKeyNumber(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('key_number', args.data.key_number);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(keyNumberAction(KEY_NUMBER_FORM_INITIAL));
            growl({ type: 'success', message: response.message, time: 50000 });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherFindKeyNumber() {
    yield takeLatest(FIND_KEY_NUMBER_SAGA, workerFindKeyNumber);
}